import { ErrorHandler } from '@angular/core';
import { ApplicationinsightsAngularpluginErrorService } from '@microsoft/applicationinsights-angularplugin-js';
import { TreetopPropertiesProvider } from 'shared/util-common';

export function ErrorFactory(): ErrorHandler {
  if (TreetopPropertiesProvider.properties.insights.connectionString !== null) {
    return new ApplicationinsightsAngularpluginErrorService();
  }
  return new ErrorHandler();
}
